import {rule} from '@/util/validateRules'

//行业list-国寿财
const industry_gsc = [
	{
		label: '农、林、牧、渔业',
		value: 'A',
	},
	{
		label: '采矿业',
		value: 'B',
	},
	{
		label: '制造业',
		value: 'C',
	},
	{
		label: '电力、热力、燃气及水生产和供应业',
		value: 'D',
	},
	{
		label: '建筑业',
		value: 'E',
	},
	{
		label: '批发和零售业',
		value: 'F',
	},
	{
		label: '交通运输、仓储和邮政业',
		value: 'G',
	},
	{
		label: '住宿和餐饮业',
		value: 'H',
	},
	{
		label: '信息传输、软件和信息技术服务业',
		value: 'I',
	},
	{
		label: '金融业',
		value: 'J',
	},
	{
		label: '房地产业',
		value: 'K',
	},
	{
		label: '租赁和商务服务业业',
		value: 'L',
	},
	{
		label: '科学研究和技术服务业',
		value: 'M',
	},
	{
		label: '水利、环境和公共设施管理业',
		value: 'N',
	},
	{
		label: '居民服务、修理和其他服务业',
		value: 'O',
	},
	{
		label: '教育',
		value: 'P',
	},
	{
		label: '卫生和社会工作',
		value: 'Q',
	},
	{
		label: '文化、体育和娱乐业',
		value: 'R',
	},
	{
		label: '公共管理、社会保障和社会组织',
		value: 'S',
	},
]

//行业list-国寿财
export const industry_azx = [
	{
		label: '制造业',
		value: 'C',
	},
	{
		label: '建筑业',
		value: 'E',
	},
	{
		label: '批发和零售业',
		value: 'F',
	},
	{
		label: '交通运输、仓储和邮政业',
		value: 'G',
	},
	{
		label: '住宿和餐饮业',
		value: 'H',
	},
	{
		label: '信息传输、软件和信息技术服务业',
		value: 'I',
	},
	{
		label: '租赁和商务服务业业',
		value: 'L',
	},
	{
		label: '水利、环境和公共设施管理业',
		value: 'N',
	},
	{
		label: '居民服务、修理和其他服务业',
		value: 'O',
	},
	{
		label: '文化、体育和娱乐业',
		value: 'R',
	},
]

export const unitOption = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 140,
	column: [
		{
			label: '证件类型',
			prop: 'certType',
			type: 'select',
			display: false,
			disabled: false,
			dicData: [
				{
					label: '营业执照',
					value: '4',
				},
				{
					label: '个人身份证',
					value: '100',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 证件类型',
					trigger: 'blur',
				},
			],
		},
		{
			label: '企业名称',
			prop: 'name',
			display: true,
			slot: true,
			rules: [
				{
					required: true,
					message: '请输入或选择 企业名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '联系人',
			prop: 'name1',
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 投保人姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '联系人',
			prop: 'principal',
			display: true,
			rules: [
				{
					required: true,
					message: '请输入 企业联系人',
					trigger: 'blur',
				},
				{
					required: true,
					validator: (rule, value, callback) => {
						if (value.length <= 1) {
							callback(new Error('企业联系人不正确!'))
						} else {
							callback()
						}
					},
				},
			],
		},
		{
			label: '统一信用代码',
			prop: 'code',
			display: true,
			rules: [
				{
					required: true,
					validator: rule.validatorCreditCode,
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证号',
			prop: 'code1',
			display: false,
			rules: [
				{
					required: true,
					validator: rule.validatorIdNo,
					trigger: 'blur',
				},
			],
		},
		{
			label: '手机号码',
			prop: 'mobile',
			placeholder: '请输入 联系人手机号码',
			rules: [
				{
					required: true,
					message: '请输入 联系人手机号码',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
		},
		{
			label: '所在地区',
			type: 'cascader',
			prop: 'areaCode',
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicData: [],
			filterable: true,
			display: true,
			emitPath: false,
			rules: [
				{
					required: true,
					message: '请选择 所在地区',
					trigger: 'change',
				},
			],
		},
		{
			label: '详细地址',
			prop: 'address',
			row: false,
			display: true,
			rules: [
				{
					required: true,
					message: '请输入 详细地址',
					trigger: 'blur',
				},
			],
		},
		{
			label: '邮箱',
			prop: 'email',
			placeholder: '请输入 联系人邮箱',
			span: 12,
			row: true,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 企业联系人邮箱',
					trigger: 'blur',
				},
			],
		},
		{
			label: '所属行业',
			prop: 'industry',
			span: 24,
			display: false,
			type: 'select',
			dicData: industry_gsc,
			rules: [
				{
					required: true,
					message: '请选择 所属行业',
					trigger: 'change',
				},
			],
		},
		{
			//(comment :'企业类别\\n1-全民所有制企业,2-集体所有制企业3-联营企业,4-外资企业,5-私营企业,6-合资企业")
			label: '企业类别',
			prop: 'category',
			type: 'select',
			display: false,
			dicData: [
				{
					label: '全民所有制企业',
					value: 1,
				},
				{
					label: '集体所有制企业',
					value: 2,
				},
				{
					label: '联营企业',
					value: 3,
				},
				{
					label: '外资企业',
					value: 4,
				},
				{
					label: '私营企业',
					value: 5,
				},
				{
					label: '合资企业',
					value: 6,
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 企业类别',
					trigger: 'change',
				},
			],
		},

		//安泽
		{
			label: '注册资本(万)',
			prop: 'registerCapital',
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 注册资本',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorNumber,
				},
			],
		},
		{
			label: '证件有效期类型',
			prop: 'termType',
			type: 'select',
			display: false,
			dicData: [
				{
					label: '长期',
					value: 1,
				},
				{
					label: '短期',
					value: 2,
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 证件有效期类型',
				},
			],
			control: (val, form) => {
				return {
					termEnd: {
						display: val == 2,
					},
				}
			},
		},
		//证件有效期类型
		{
			label: '有效期起始日期',
			prop: 'termStart',
			display: false,
			type: 'date',
			valueFormat: 'yyyy-MM-dd',
			format: 'yyyy-MM-dd',
			rules: [
				{
					required: true,
					message: '请选择 有效期起始日期',
				},
			],
		},
		{
			label: '有效期终止日期',
			prop: 'termEnd',
			display: false,
			type: 'date',
			valueFormat: 'yyyy-MM-dd',
			format: 'yyyy-MM-dd',
			rules: [
				{
					required: true,
					message: '请选择 有效期终止日期',
				},
			],
		},
		{
			label: '经营范围',
			prop: 'businessScope',
			type: 'textarea',
			display: false,
			minRows: 2,
			maxRows: 3,
			row: true,
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入 经营范围',
				},
			],
		},
		{
			label: '企业负责人身份证正面',
			prop: 'identityFront',
			type: 'upload',
			display: false,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			rules: [
				{
					required: true,
					message: '请上传企业负责人身份证正面',
					trigger: 'blur',
				},
			],
		},
		{
			label: '企业负责人身份证反面',
			prop: 'identityBack',
			type: 'upload',
			display: false,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			rules: [
				{
					required: true,
					message: '请上传企业负责人身份证反面',
					trigger: 'blur',
				},
			],
		},
		{
			label: '营业执照',
			prop: 'license',
			type: 'upload',
			display: true,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			rules: [
				{
					required: true,
					message: '请上传营业执照',
					trigger: 'blur',
				},
			],
		},
		{
			label: '示例',
			prop: 'example',
			type: 'upload',
			listType: 'picture-img',
			display: true,
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		},
		// {
		//   label: '投保人声明盖章件',
		//   prop: 'insureConfirmFile',
		//   type: 'upload',
		//   display: false,
		//   listType: 'picture-img',
		//   action: '/dist/distInsure/uploadFile',
		//   propsHttp: {
		//     res: 'data'
		//   },
		//   dragFile: true,
		//   accept: 'image/png, image/jpeg',
		//   tip: '请上传大小不超过2Mb的jpg/png文件',
		//   rules: [{
		//     required: true,
		//     message: '请上传投保人声明盖章件',
		//     trigger: 'blur'
		//   }
		//   ]
		// },
		// {
		//   label: '示例',
		//   prop: 'example123',
		//   span: 4,
		//   type: 'upload',
		//   display: false,
		//   listType: 'picture-img',
		//   propsHttp: {
		//     res: 'data'
		//   },
		//   disabled: true
		// }, {
		//   label: '',
		//   span: 2,
		//   prop: 'myDownLoadTemp',
		//   display: false
		// }
	],
}

export const unitCommonOption = {
	submitBtn: true,
	submitText: '确认',
	menuBtn: true,
	labelWidth: 140,
	column: [
		{
			label: '企业名称',
			prop: 'unit_name',
			slot: true,
			rules: [
				{
					required: true,
					message: '请输入或选择 企业名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '联系人',
			prop: 'legal_person',
			rules: [
				{
					required: true,
					message: '请输入 企业联系人',
					trigger: 'blur',
				},
				{
					required: true,
					validator: (rule, value, callback) => {
						if (value.length <= 1) {
							callback(new Error('企业联系人不正确!'))
						} else {
							callback()
						}
					},
				},
			],
		},
		{
			label: '统一信用代码',
			prop: 'unit_code',
			display: true,
			rules: [
				{
					required: true,
					validator: rule.validatorCreditCode,
					trigger: 'blur',
				},
			],
		},
		{
			label: '手机号码',
			prop: 'legal_person_mobile',
			placeholder: '请输入 联系人手机号码',
			rules: [
				{
					required: true,
					message: '请输入 联系人手机号码',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
		},
		{
			label: '所在地区',
			type: 'cascader',
			prop: 'area_code',
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicData: [],
			filterable: true,
			showAllLevels: true,
			display: true,
			rules: [
				{
					required: true,
					message: '请选择 所在地区',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '详细地址',
			prop: 'unit_addr',
			row: false,
			display: true,
			rules: [
				{
					required: true,
					message: '请输入 详细地址',
					trigger: 'blur',
				},
			],
		},
		{
			label: '营业执照',
			prop: 'bus_license',
			type: 'upload',
			display: true,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			tip: '请上传大小不超过2Mb的jpg/png文件',
			rules: [
				{
					required: true,
					message: '请上传营业执照',
					trigger: 'blur',
				},
			],
		},
		{
			label: '示例',
			prop: 'example',
			type: 'upload',
			listType: 'picture-img',
			display: true,
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		},
	],
}

export const FileConfirmOption = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 140,
	column: [
		{
			label: '投保人声明盖章件',
			prop: 'insureConfirmFile',
			type: 'upload',
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			disabled: false,
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			rules: [
				{
					required: true,
					message: '请上传投保人声明盖章件',
					trigger: 'blur',
				},
			],
		},
		{
			label: '示例',
			prop: 'insureConfirmSample',
			span: 4,
			type: 'upload',
			listType: 'picture-img',
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		},
		{
			label: '',
			span: 2,
			prop: 'insureConfirmUrl',
		},
	],
}
